module.exports = __webpack_public_path__ + "img/4.c899c006.png";